import Action, {GET, POST_FORM,POST} from "../common/Action";

export const getOrdersAction = new Action('GET_ORDERS', POST, 'order/list');
export const getOrderAction = new Action('GET_ORDER', GET, ({id}) => `order/${id}`);

export const getOrders = (query) => getOrdersAction.callApi(query);
export const getOrder = (id) => getOrderAction.callApi(null, ({id}));